import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { ViewAgentMonitor } from "../Features/Getallagentsmonitors";
import { RootState, AppDispatch } from "../Appstore/store";
import { formatDate } from "../helper";
import { useNavigate } from "react-router-dom";
import { setIsLoading } from "../Features/loadingSlice";

interface AgentMonitor {
  id?: number;
  name?: string;
  email?: string;
  phone_number?: string;
  status?: number;
  role?: number;
  createdAt?: string;
  updatedAt?: string;
}

function Viewsmtpgateways() {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { id }: any = useParams();

  const { error, agentmonitordata, loading } = useSelector(
    (state: RootState) => state.agentmonitor
  );
  const record: AgentMonitor | any = agentmonitordata.find(
    (recodID) => recodID.id === Number(id)
  );

  useEffect(() => {
    if (id) {
      dispatch(setIsLoading(true));
      dispatch(ViewAgentMonitor(id))
        .unwrap()
        .catch((err) => {
          console.error("Error fetching agent monitor:", err);
        })
        .finally(() => {
          setTimeout(() => dispatch(setIsLoading(false)), 500);
        });
    }
  }, [id, dispatch]);

  const navigatetobackpage = () => {
    navigate(-1);
  };

  if (error) {
    <div>No found data</div>;
  }

  return (
    <>
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content">
            <div className="container-fluid">
              <div className="card mt-4 shadow-sm border rounded">
                <div className="card-header bg-white p-3 d-flex justify-content-md-between">
                  <h2 className="w-100 mb-md-0 fs-3">View User</h2>
                  <Link to={""} className="text-decoration-none">
                    <button
                      onClick={navigatetobackpage}
                      className="btn btn-info text-white d-flex align-items-center fw-semibold"
                    >
                      <IoMdArrowRoundBack /> Back
                    </button>
                  </Link>
                </div>

                <div className="card-body px-0 py-0">
                  <div className="table-responsive">
                    <table className="table mb-0 table-bordered">
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan={7} height={100}>
                              <div className="text-center">
                                <div className="loader"></div>
                              </div>
                            </td>
                          </tr>
                        ) : error ? (
                          <tr>
                            <td colSpan={7} height={100}>
                              <div className="text-center">
                                <p className="mb-0 fs-4 fw-semibold">
                                  No data found
                                </p>
                              </div>
                            </td>
                          </tr>
                        ) : (
                          <>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Name
                              </th>
                              <td className="p-3">{record?.name}</td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Email
                              </th>
                              <td className="p-3">{record?.email}</td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Phone Number
                              </th>
                              <td className="p-3">{record?.phone_number || "-"}</td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Role
                              </th>
                              <td className="p-3">
                                {record?.role === 1 ? "Agents" : "Monitors"}
                              </td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Status
                              </th>
                              <td
                                className={`p-3 fw-bold ${record?.status === 1
                                  ? "text-success "
                                  : "text-danger "
                                  }`}
                              >
                                {record?.status === 1 ? "Active" : "Deactive"}
                              </td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Created At
                              </th>
                              <td>{formatDate(record?.createdAt)}</td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Updated At
                              </th>
                              <td>{formatDate(record?.updatedAt)}</td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}
export default Viewsmtpgateways;